import { Component } from '@angular/core';

@Component({
  selector: 'bp-forbidden',
  templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent { }
